/**
 * Numbered Voluum-style tracking step (accordion trigger + panel).
 * For Media Devoted | Created By Ciro Autiero
 */

import { ChevronDown, ChevronUp } from 'lucide-react';

import { cn } from '@/lib/utils';

import type { FC, ReactNode } from 'react';

export interface LanderTrackingAccordionProps {
  stepNumber: number;
  title: string;
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
}

const LanderTrackingAccordion: FC<LanderTrackingAccordionProps> = ({
  stepNumber,
  title,
  open,
  onToggle,
  children,
}) => (
  <div className="overflow-hidden rounded-lg border border-border bg-card shadow-sm">
    <button
      type="button"
      onClick={onToggle}
      className="flex w-full items-center gap-3 px-3 py-2.5 text-left transition-colors hover:bg-muted/30"
    >
      <span
        className={cn(
          'flex h-7 w-7 shrink-0 items-center justify-center rounded-full',
          'bg-primary/15 text-xs font-bold text-primary',
        )}
        aria-hidden
      >
        {stepNumber}
      </span>
      <span className="min-w-0 flex-1 text-sm font-semibold text-foreground">
        {title}
      </span>
      {open ? (
        <ChevronUp className="h-4 w-4 shrink-0 text-primary" aria-hidden />
      ) : (
        <ChevronDown className="h-4 w-4 shrink-0 text-primary" aria-hidden />
      )}
    </button>
    {open ? (
      <div className="space-y-3 border-t border-border/70 bg-muted/[0.06] px-3 py-3">
        {children}
      </div>
    ) : null}
  </div>
);

export default LanderTrackingAccordion;
